import { EventPriority } from 'library/ts/events/EventPriority';
export class EventDispatcher {
    #ownerName;
    #eventSubscriptions = {};
    constructor(ownerName = undefined) {
        this.#ownerName = ownerName;
    }
    get name() {
        return 'EventDispatcher';
    }
    get ownerName() {
        return this.#ownerName;
    }
    get utils() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    getEventSubscribers = () => {
        let totalEvents = 0;
        let totalListeners = 0;
        for (const key in this.#eventSubscriptions) {
            if (Object.prototype.hasOwnProperty.call(this.#eventSubscriptions, key)) {
                totalEvents++;
                totalListeners += (this.#eventSubscriptions[key]).length;
            }
        }
        return {
            totalEvents: totalEvents,
            totalListeners: totalListeners,
            subscriptions: this.#eventSubscriptions
        };
    };
    addEventListener = (event, callback, subscriber = undefined) => {
        let eventType;
        let timesToDispatch;
        let priority = EventPriority.NORMAL;
        if (this.utils.Type.isString(event)) {
            eventType = event;
        }
        if (this.utils.Type.isObject(event) && !this.utils.Type.isEmpty(event)) {
            eventType = event?.type;
            timesToDispatch = event?.timesToDispatch;
            priority = event?.priority || EventPriority.NORMAL;
        }
        if (this.utils.Type.isEmpty(eventType) || !this.utils.Type.isFunction(callback)) {
            console.warn(this.name, 'Event subscription ignored:', 'event:', event, 'callback:', callback, 'subscriber.name:', subscriber?.name);
            return;
        }
        let subscribers = this.#eventSubscriptions[eventType];
        if (this.utils.Type.isUndefined(subscribers)) {
            subscribers = this.#eventSubscriptions[eventType] = [];
        }
        subscribers.push({
            callback: callback,
            timesToDispatch: timesToDispatch,
            subscriber: subscriber,
            subscriberName: subscriber?.name,
            priority: priority
        });
        subscribers.sort(this.utils.Array.sortByProperty('priority', false));
    };
    removeEventListener = (eventName, callback) => {
        const removeEvent = (event) => {
            if (this.#eventSubscriptions[event]?.length === 0) {
                delete this.#eventSubscriptions[event];
            }
        };
        if (this.#eventSubscriptions[eventName]) {
            const subscribers = this.#eventSubscriptions[eventName];
            for (let i = subscribers?.length - 1; i >= 0; --i) {
                if (subscribers[i]?.callback === callback) {
                    subscribers.splice(i, 1);
                    removeEvent(eventName);
                    subscribers?.sort(this.utils.Array.sortByProperty('priority', false));
                    return true;
                }
            }
        }
        return false;
    };
    clear = () => {
        const unsubscribeFromEvent = (eventType) => {
            const subscribers = this.#eventSubscriptions[eventType];
            if (this.utils.Type.isArray(subscribers) && !this.utils.Type.isEmpty(subscribers)) {
                subscribers.forEach((subscriber) => {
                    this.removeEventListener(eventType, subscriber.callback);
                });
            }
        };
        return new Promise((resolve) => {
            for (const eventType in this.#eventSubscriptions) {
                if (Object.prototype.hasOwnProperty.call(this.#eventSubscriptions, eventType)) {
                    unsubscribeFromEvent(eventType);
                    delete this.#eventSubscriptions[eventType];
                }
            }
            this.#eventSubscriptions = {};
            resolve({ msg: 'done' });
        });
    };
    dispatchEvent = (eventVO, context = this) => {
        const subscribers = this.#eventSubscriptions[eventVO?.type];
        if (this.utils.Type.isUndefined(subscribers)) {
            return;
        }
        const processNumberOfDispatches = (subs, myIndex) => {
            if (this.utils.Type.isNumber(subs[myIndex]?.timesToDispatch) && subs[myIndex]?.timesToDispatch > 0) {
                console.log(this.name, 'dispatchEvent:', eventVO?.type, 'timesToDispatch:', subs[myIndex]?.timesToDispatch, 'Dispatch + Decrement');
                --subs[myIndex].timesToDispatch;
                if (subs[myIndex]?.timesToDispatch === 0) {
                    console.log(this.name, 'dispatchEvent:', eventVO?.type, 'timesToDispatch:', subs[myIndex]?.timesToDispatch, 'Unsubscribe');
                    delete subs[myIndex]?.timesToDispatch;
                    delete subs[myIndex]?.subscriber;
                    delete subs[myIndex]?.subscriberName;
                    this.removeEventListener(eventVO?.type, subs[myIndex]?.callback);
                    subs.splice(myIndex, 1);
                }
            }
        };
        let index = subscribers?.length;
        while ((this.utils.Type.isNumber(index) && index > 0)) {
            index--;
            if (this.utils.Type.isDefined(subscribers[index]) && this.utils.Type.isDefined(subscribers[index]?.callback?.apply)) {
                subscribers[index]?.callback?.call(context, eventVO);
                processNumberOfDispatches(subscribers, index);
            }
            else {
                console.log(this.name, 'dispatchEvent: undefined subscriber -> do not dispatch event', subscribers[index]);
            }
        }
    };
}
